import type { Maybe } from '@adornis/base/utilTypes.js';
import { ChemistryLitElement } from '@adornis/chemistry/chemistry-tailwind-lit-element.js';
import { html, nothing } from 'lit';
import { customElement, property, state } from 'lit/decorators.js';

/**
 * @customElement chancen-component-icon-spoiler
 */
@customElement('chancen-component-icon-spoiler')
export class ChancenComponentIconSpoiler extends ChemistryLitElement {
  @property() icon = 'visibility';
  @property() hint: Maybe<string> = null;

  @state() private _open = false;

  override render() {
    if (this._open) {
      return html`<cr-flex horizontal crossaxis-center space="sm">
        <cr-button mode="icon" icon="close" @click=${() => (this._open = false)}></cr-button>
        <cr-text><slot></slot><cr-text>
      </cr-flex>`;
    }

    return html` <cr-button mode="icon" icon="${this.icon}" @click=${() => (this._open = true)}>
      ${(this.hint?.length ?? 0) > 0 ? html`<cr-tooltip><cr-text>${this.hint}<cr-text></cr-tooltip>` : nothing}
    </cr-button>`;
  }
}
